import styled from 'styled-components'
import { Text, TextButton, Link } from '@amzn/storm-ui'
import { fadeIn, fadeOut } from '../../commons/styles'

export const CarouselProgressDotContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => theme.mobile.spacing.micro} 0;
  padding-top: 2px;
`

export const FadeInContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.mobile.spacing.large};
  margin-bottom: ${({ theme }) => theme.mobile.spacing.base};
`

export const ProgressFadeInContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.mobile.spacing.medium} 0 ${({ theme }) => theme.mobile.spacing.medium} 0;
`

export const SlideContainer = styled.div<{ isActive: boolean; isFirstSlide: boolean; isLastSlide: boolean }>`
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  ${({ isActive }) => (isActive ? fadeIn : fadeOut)};
  width: 100%;
  margin: 0 ${({ isLastSlide }) => (isLastSlide ? '70px' : 0)} 0 ${({ isFirstSlide }) => (isFirstSlide ? '70px' : 0)};
`

export const ProgressDotContainer = styled(TextButton)`
  display: inline-block;
  position: relative;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: ${({ theme }) => theme.mobile.spacing.micro};

  &:hover {
    background-color: ${({ theme }) => theme.palette.white};
  }

  &:last-child {
    margin-right: 0;
  }

  &::before {
    content: '';
    background-color: ${({ theme }) => theme.palette.white};
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    border-radius: 50%;
    opacity: 30%;
  }
`

export const ProgressDotComplete = styled.div`
  display: block;
  position: relative;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
`

export const HeadlineText = styled(Text)`
  color: ${({ theme }) => theme.palette.white};
  text-align: left;
  margin-bottom: ${({ theme }) => theme.mobile.spacing.micro};
`

export const CaptionText = styled(Text)`
  color: ${({ theme }) => theme.palette.white};
  text-align: left;
  font-size: 15px;
  line-height: 22px;
`

export const ContentContainer = styled.div`
  margin: 0 46px;
  flex-grow: 1;
`

export const SlideLink = styled(Link)`
  &&& {
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.white};
  }
  display: block;
  margin-top: ${({ theme }) => theme.mobile.spacing.mini};
  font-size: 15px;
  line-height: 22px;
  text-align: right;
`
